module.exports = __webpack_public_path__ + "static/navydoubleknit-3bbf974efc9c1a5413433b3711e12a8e.jpeg";